import React, { useContext, useEffect, useState } from "react";
import Vehicleimg from "../../../src/assets/images/VehicleM&HCV.svg";
import Scvimg from "../../../src/assets/images/Vehicle-SCV&PU.svg";
import Cvimg from "../../../src/assets/images/Vehicle-CVPassenger.svg";
import Ilcvimg from "../../../src/assets/images/Vehicle-ILCV.svg";
import totalv from "../../../src/assets/images/TotalVehicle.svg";
import { Link } from "react-router-dom";
import vdetail from "../../../src/assets/images/RTO-Detail.svg";
import axios from "axios";
import { FilterContext } from "../../context/Filter";

const Vehiclecard = () => {
  const [totalVehicles, setTotalVehicles] = useState(null);
  const [mhcvCardCnt, setmhcvCardCnt] = useState(null);
  const [ilcvCnt, setilcvCnt] = useState(null);
  const [cvpasscnt, setcvpasscnt] = useState(null);
  const [scvpucnt, setscvpucnt] = useState(null);
  const [error, setError] = useState(null);

  const { arn: parArn, childArn } = useContext(FilterContext);
  const arn = childArn || parArn;

  const arr = ["MCV Truck", "HCV Cargo", "HCV Const"];

  const fetchTotalVehicles = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}totalVehicles`,
        { parArn, childArn }
      );
      setTotalVehicles(res?.data?.result?.doc_count);
      return res.data;
    } catch (error) {
      console.error(`API fetch error (${totalVehicles}):`, error);
      return null;
    }
  };

  const fetchMAndHcvTrucks = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}mhcvCardCnt`,
        { parArn, childArn }
      );
      setmhcvCardCnt(res?.data?.result);
      return res.data;
    } catch (error) {
      console.error(`API fetch error (${"mhcvCardCnt"}):`, error);
      return null;
    }
  };

  const fetchCvpasscnt = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}cvpasscnt`,
        { parArn, childArn }
      );
      setcvpasscnt(res?.data?.result);
      return res.data;
    } catch (error) {
      console.error(`API fetch error (${"cvpasscnt"}):`, error);
      return null;
    }
  };

  const fetchScvpucnt = async () => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}scvpucnt`, {
        parArn,
        childArn,
      });
      setscvpucnt(res?.data?.result);
      return res.data;
    } catch (error) {
      console.error(`API fetch error (${"scvpucnt"}):`, error);
      return null;
    }
  };

  const fetchIlcvCnt = async () => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}ilcvCnt`, {
        parArn,
        childArn,
      });
      setilcvCnt(res?.data?.result);
      return res.data;
    } catch (error) {
      console.error(`API fetch error (${"ilcvCnt"}):`, error);
      return null;
    }
  };

  useEffect(() => {
    const loadAll = async () => {
      try {
        fetchTotalVehicles();
        fetchMAndHcvTrucks();
        fetchCvpasscnt();
        fetchScvpucnt();
        fetchIlcvCnt();
      } catch (err) {
        setError("Failed to fetch data");
      }
    };

    if (arn) loadAll();
  }, [arn, parArn, childArn]);

  return (
    <div className="block sm:flex m-1 pl-2 rounded-lg">
      {/* -------- Left column (M&HCV + ILCV) -------- */}
      <div className="flex flex-col w-full">
        {/* M&HCV */}
        <div className="bg-[#D0EBFF] flex p-3 gap-4 shadow-md mb-2 rounded-md w-full">
          <img src={Vehicleimg} alt="M&HCV Truck" />
          <div className="flex flex-col w-full">
            {mhcvCardCnt?.map((item, index) => (
              <div
                key={index}
                className={`flex justify-between items-center text-xs ${
                  index === 0 ? "font-semibold mb-1" : ""
                }`}
              >
                <span>{item?.key}</span>
                <span>{item?.doc_count ?? "No Vehicles in M&HCV"}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ILCV */}
        <div className="bg-[#C6FFE7] flex p-3 gap-4 shadow-md mb-2 rounded-md w-full">
          <img src={Ilcvimg} alt="ILCV" />
          <div className="flex flex-col w-full">
            {ilcvCnt?.map((item, index) => (
              <div
                key={index}
                className={`flex justify-between items-center text-xs ${
                  index === 0 ? "font-semibold mb-1" : ""
                }`}
              >
                <span>{item?.key}</span>
                <span>{item?.doc_count ?? "No Vehicles in ILCV"}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* -------- Center column (Total Vehicles card) -------- */}
      <div className="m-1 flex flex-col border p-3 opacity-80 rounded-md bg-white w-full sm:w-1/4 items-center justify-center text-center">
        <img className="mb-1" src={totalv} alt="Total Vehicles" />
        {error ? (
          <div className="text-red-500 text-xs">{error}</div>
        ) : (
          <div className="text-xs font-semibold">
            Total Vehicles: {totalVehicles ?? "Loading..."}
          </div>
        )}
        <Link to="/vehicle" className="flex justify-center mt-2">
          <img className="w-8 h-8" src={vdetail} alt="RTO Detail" />
        </Link>
      </div>

      {/* -------- Right column (CV Passenger + SCV & PU) -------- */}
      <div className="flex flex-col w-full">
        {/* CV Passenger */}
        <div className="bg-[#FFE3BA] flex p-3 gap-4 shadow-md pb-5 rounded-md w-full">
          <img src={Cvimg} alt="CV Passenger" />
          <div className="flex flex-col w-full">
            {cvpasscnt?.map((item, index) => (
              <div
                key={index}
                className={`flex justify-between items-center text-xs ${
                  index === 0 ? "font-semibold mb-1" : ""
                }`}
              >
                <span>{item?.key}</span>
                <span>{item?.doc_count ?? "No Vehicles in CV Passenger"}</span>
              </div>
            ))}
          </div>
        </div>

        {/* SCV & PU */}
        <div className="bg-[#C8FAFF] flex mt-3 p-3 gap-4 shadow-md mb-2 rounded-md w-full">
          <img src={Scvimg} alt="SCV & PU" />
          <div className="flex flex-col w-full">
            {scvpucnt?.map((item, index) => (
              <div
                key={index}
                className={`flex justify-between items-center text-xs ${
                  index === 0 ? "font-semibold mb-1" : ""
                }`}
              >
                <span>{item?.key}</span>
                <span>{item?.doc_count ?? "No Vehicles in SCV & PU"}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vehiclecard;
